document.addEventListener("DOMContentLoaded", function () {
  var radioBoleta = document.querySelector('input[value="boleta"]');
  var radioFactura = document.querySelector('input[value="factura"]');
  var radioButton = document.querySelectorAll(".radio-button");
  var cartAttributes = document.getElementById("cart-attributes");
  var cartAttributesInputs = cartAttributes.querySelectorAll('#cart-attributes input.required-field');
  var form = document.getElementById("cart_form");
  var submitButton = document.querySelector('button[type="submit"][name="checkout"]');
  var isFormActive = false;
  var errorSelect = document.getElementById("error-select");
  var errorMissing = document.getElementById("error-missing");

  function disableForm() {
    isFormActive = false;
  }

  function enableForm() {
    isFormActive = true;
    errorMissing.classList.remove("enabled");
  }

  function setFieldsRequired(required) {
    cartAttributesInputs.forEach(function (input) {
      if (required) {
        input.setAttribute('required', '');
      } else {
        input.removeAttribute('required');
      }
    });
  }

  function checkRadioButtons() {
    if (!radioBoleta.checked && !radioFactura.checked) {
      disableForm();
      setFieldsRequired(false);
    } else if (radioBoleta.checked) {
      enableForm();
      cartAttributes.classList.remove("enabled");
      errorSelect.classList.remove("enabled");
      setFieldsRequired(false); // No se requieren campos para boleta
    } else if (radioFactura.checked) {
      disableForm();
      setFieldsRequired(true); // Se requieren campos para factura
      cartAttributesInputs.forEach(function (input) {
        input.addEventListener("input", function () {
          if (input.value.trim() !== "") {
            input.classList.remove("missing");
          }
          if (
            Array.from(cartAttributesInputs).every(function (input) {
              return input.value.trim() !== "";
            })
          ) {
            enableForm();
          } else {
            disableForm();
          }
        });
      });
      cartAttributes.classList.add("enabled");
      errorSelect.classList.remove("enabled");
    }
  }

  form.addEventListener("submit", function (event) {
    if (!radioBoleta.checked && !radioFactura.checked) {
      event.preventDefault();
      errorSelect.classList.add("enabled");
    } else if (radioFactura.checked) {
      var areInputsFilled = Array.from(cartAttributesInputs).every(function (
        input
      ) {
        return input.value.trim() !== "";
      });

      if (!areInputsFilled) {
        event.preventDefault();
        cartAttributesInputs.forEach(function (input) {
          if (input.value.trim() === "") {
            input.classList.add("missing");
          } else {
            input.classList.remove("missing");
          }
        });
        errorMissing.classList.add("enabled");
      }
    } else if (!isFormActive) {
      event.preventDefault();
    } else {
    }
  });

  radioBoleta.addEventListener("change", checkRadioButtons);
  radioFactura.addEventListener("change", checkRadioButtons);

  checkRadioButtons();

  window.addEventListener("pageshow", function (event) {
    checkRadioButtons();
  });
});
